const { JsonReconstructor } = require('./json-stream/reconstructor')

class ToolCallStreamAssembler {
  constructor() {
    this.byId = new Map()
    this.byIndex = new Map()
  }

  createState(toolCall) {
    return {
      reconstructor: new JsonReconstructor(),
      args: '',
      toolCall: {
        ...toolCall,
        function: {
          ...(toolCall.function || {}),
          name: '',
          arguments: '{}'
        }
      }
    }
  }

  stateFor(toolCall) {
    const { id, index } = toolCall
    const indexKey = index === undefined || index === null ? null : String(index)
    let state = id ? this.byId.get(id) : null

    if (!state && indexKey !== null) {
      const indexed = this.byIndex.get(indexKey)
      if (!id || !indexed || !indexed.toolCall.id || indexed.toolCall.id === id) {
        state = indexed
      }
    }
    if (!state) state = this.createState(toolCall)

    if (id) {
      state.toolCall.id = id
      this.byId.set(id, state)
    }
    if (indexKey !== null) this.byIndex.set(indexKey, state)
    return state
  }

  process(toolCall) {
    const state = this.stateFor(toolCall)
    const fn = toolCall.function || {}
    const assembledFunction = state.toolCall.function || (state.toolCall.function = {})

    if (fn.name) {
      const currentName = assembledFunction.name || ''
      assembledFunction.name = fn.name.startsWith(currentName)
        ? fn.name
        : currentName + fn.name
    }
    if (fn.arguments) {
      state.args += fn.arguments
      state.reconstructor.process(fn.arguments)
      const args = state.reconstructor.getValue()
      if (args !== undefined && args !== null) {
        assembledFunction.arguments = JSON.stringify(args)
      }
    }

    toolCall.id = state.toolCall.id
    toolCall.function = {
      ...fn,
      name: assembledFunction.name || fn.name || '',
      arguments: assembledFunction.arguments || '{}'
    }
    return toolCall
  }
}

module.exports = { ToolCallStreamAssembler }
